import { TopBar } from './top-bar';
import { RulesContent } from './rules-content';
import { SabaCoinEventRulesTypeEnum } from '@/types';

export const CoinEventRules = ({ 
	onClose,
	ruleType
}: {
	onClose: () => void;
	ruleType: SabaCoinEventRulesTypeEnum
}) => {

	const handleClose = () => {
		document.dispatchEvent(new CustomEvent('show-saba-coin-reward-level-rule', {
			detail: { openRewardLevelRule: false }
		}));
		onClose();
	}

	return (
		<div 
			className="reward-main"
			data-open="true"
		>
			<TopBar onClose={handleClose} />
			<RulesContent initRuleType={ruleType} />
		</div>
	);
};